import React from 'react';
import { Reveal } from './motion';

export default function ClosingCTA({ onLogin, onRequestDemo }) {
  return (
    <section className="relative overflow-hidden bg-slate-950 py-24 sm:py-32">
      <div
        className="pointer-events-none absolute inset-0 bg-[radial-gradient(80%_70%_at_50%_120%,rgba(56,189,248,0.22),transparent_65%)]"
        aria-hidden="true"
      />
      <div className="relative mx-auto max-w-3xl safe-area-x text-center sm:px-6">
        <Reveal>
          <h2 className="text-3xl font-bold leading-tight tracking-tight text-white sm:text-5xl">
            Your season is already complicated.
            <br />
            <span className="bg-gradient-to-r from-sky-300 to-blue-500 bg-clip-text text-transparent">
              The software shouldn&rsquo;t be.
            </span>
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg text-slate-400">
            Twenty minutes, your actual roster and boats on screen, and an honest answer about
            whether this fits your club.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="mt-10">
          <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              onClick={onRequestDemo}
              className="w-full rounded-xl bg-white px-8 py-4 text-base font-semibold text-slate-900 shadow-xl shadow-sky-900/30 transition-transform hover:scale-[1.02] active:scale-95 sm:w-auto"
            >
              Request a demo
            </button>
            <button
              onClick={onLogin}
              className="w-full rounded-xl border border-white/15 bg-white/5 px-8 py-4 text-base font-semibold text-white transition-colors hover:border-white/30 hover:bg-white/10 sm:w-auto"
            >
              I already have an account
            </button>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
